import { motion } from 'framer-motion';
import './SiteBlob.css';

function SiteBlob() {
  return (
    <motion.div
      className="site-blob"
      aria-hidden="true"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 1.5, delay: 0.3 }}
    >
      <div className="site-blob-shape">
        <div className="site-blob-mesh" />
        <div className="site-blob-glow" />
      </div>
    </motion.div>
  );
}

export default SiteBlob;
